
    <app-my-json class="my-5" [table]= "'userRole'" [q] = "getNew()" [create] = 'true' > </app-my-json>
    